import { useState } from 'react';
import StoreSettingsPage from './detail/StoreSettingsPage';
import BrandingEmailTab from './detail/BrandingEmailTab';
import StorefrontThemeTab from './detail/StorefrontThemeTab';

const BRANDING_TABS = [
	{ id: 'identity', label: 'Identity' },
	{ id: 'theme', label: 'Design' },
];

export default function StoreBranding() {
	const [tab, setTab] = useState('identity');

	return (
		<StoreSettingsPage title='Store - Branding'>
			{(store) => (
				<div>
					<div className='flex gap-6 border-b border-gray-200 mb-6'>
						{BRANDING_TABS.map((t) => (
							<button
								key={t.id}
								type='button'
								onClick={() => setTab(t.id)}
								className={`pb-3 text-sm ${
									tab === t.id
										? 'border-b-2 border-black text-black font-medium'
										: 'text-gray-500 hover:text-black'
								}`}
							>
								{t.label}
							</button>
						))}
					</div>

					{tab === 'identity' && <BrandingEmailTab storeId={store.storeId} />}
					{tab === 'theme' && <StorefrontThemeTab storeId={store.storeId} />}
				</div>
			)}
		</StoreSettingsPage>
	);
}
